import { Chip } from "@saviynt/design-system";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useFeatureResourceTypes } from "../../hooks/useFeatureResourceTypes";
import { useIntegrationTypeFeatures } from "../../hooks/useIntegrationTypeFeatures";
import { FormSection } from "../FormSection";

interface IntegrationTypeSectionProps {
  integrationType: string;
}

export function IntegrationTypeSection({
  integrationType,
}: IntegrationTypeSectionProps) {
  const intl = useIntl();
  const { data: featuresResponse } =
    useIntegrationTypeFeatures(integrationType);
  const { data: resourceTypesResponse } = useFeatureResourceTypes(
    featuresResponse?.features[0]?.featureName || "",
    { enabled: !!featuresResponse?.features[0]?.featureName },
  );

  const sortedResourceTypes = useMemo(
    () =>
      (resourceTypesResponse?.resourceTypes ?? [])
        .slice()
        .sort((a, b) => a.resourceTypeName.localeCompare(b.resourceTypeName)),
    [resourceTypesResponse],
  );

  const resourceCount = sortedResourceTypes.length;

  if (resourceCount === 0) {
    return null;
  }

  return (
    <FormSection
      icon="Server"
      title={intl.formatMessage(
        {
          id: "KhJcNB",
          defaultMessage: "Services Ingested ({count})",
          description: "Services ingested section title with count",
        },
        { count: resourceCount },
      )}
      subtitle={intl.formatMessage({
        id: "JzJDas",
        defaultMessage:
          "The following services will be ingested as part of this integration.",
        description: "Helper text describing the services ingested list",
      })}
      className="p-4"
    >
      <div className="flex flex-wrap gap-2">
        {sortedResourceTypes.map((rt) => (
          <Chip
            key={rt.resourceTypeCode}
            kind="subtleFilled"
            color="neutral"
            size="small"
            label={rt.resourceTypeName}
            isInteractionDisabled
          />
        ))}
      </div>
    </FormSection>
  );
}
